(() => {
  const closeSiblingDetails = (details, selector, scope) => {
    scope.querySelectorAll(selector).forEach((sibling) => {
      if (sibling !== details) {
        sibling.removeAttribute('open');
      }
    });
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;

    if (!(details instanceof HTMLDetailsElement) || !details.open) {
      return;
    }

    const accordion = details.closest('[data-faq-accordion]');

    if (!accordion) {
      return;
    }

    if (details.matches('[data-faq-list]')) {
      closeSiblingDetails(details, '[data-faq-list]', accordion);
      return;
    }

    if (details.matches('[data-faq-item]')) {
      const itemGroup = details.closest('[data-faq-items]');

      if (itemGroup) {
        closeSiblingDetails(details, '[data-faq-item]', itemGroup);
      }
    }
  }, true);
})();
